export const MODAL_STATES = {
  INIT: 'INIT',
  STATUS: 'STATUS',
};
